import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'recentdate',
  standalone: true
})
export class RecentDatePipe implements PipeTransform {
  transform(src: string): string | null {
    const dt = DateTime.fromISO(src);
    return dt.toRelative();
  }
}
